import { Button, Checkbox, FormControlLabel, Grid, makeStyles, Radio, RadioGroup } from '@material-ui/core';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getOpenDeliveryAreaFormDialog, handleOpenDeliveryAreaFormDialog, showAlertSnackbar } from '../../reducers/uiSlice';
import UniDialog from '../Common/UniDialog';
import _ from 'lodash';
import { getPartnersWarehouse, modifyPartnersWarehouse } from '../../actions/deliveryAreaActions';

const useStyles = makeStyles((theme) => ({
    rightPanel: {
        height: 600,
        overflow: 'scroll',
        backgroundColor: theme.palette.grey[700],
        borderRadius: 5,
        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(2)
    },
    rightBottomPanel: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        paddingLeft: theme.spacing(2)
    },
    leftPanel: {
        height: 700,
        borderRadius: 5,
        overflow: 'scroll',
        border: '1px solid white'
    },
    radioGroup: {
        marginLeft: theme.spacing(2)
    }
}));

function AssignmentDialog(props) {
    const {t} = useTranslation('deliveryAreaManagement');
    const dispatch = useDispatch();
    const classes = useStyles();

    const { warehouses, partners, authorizedWarehouses } = props;
    
    const openModalObject = useSelector(getOpenDeliveryAreaFormDialog);

    const oldSelectedPartner = useRef(partners[0]?.id + '');

    const [selectedPartner, setSelectedPartner] = useState(null);
    const [selectedWarehouses, setSelectedWarehouses] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [savedRelationship, setSavedRelationship] = useState([]);
    const [indicateSaveOpen, setIndicateSaveOpen] = useState(false);
    const [selectedCombined, setSelectedCombined] = useState('');
    const [auth, setAuth] = useState([]);
    const [noAuth, setNoAuth] = useState([]);



    const handleSelectedPartner = (event) => {
        setSelectedPartner(event.target.value)
    };
    const onClose = () => {
        dispatch(handleOpenDeliveryAreaFormDialog({open: false}))
    }
    const handleAllWarehousesClick = () => {
        if(selectAll) {
            setSelectedWarehouses([]);
        } else {
            setSelectedWarehouses(authorizedWarehouses.map((item)=>{return item + ''}));
        }
        setSelectAll(!selectAll);
    }
    const handleWarehouseClick = (branchId) => {
        let selectedWarehousesClone = _.cloneDeep(selectedWarehouses);
        let index = selectedWarehousesClone.indexOf(branchId + '');
        if(index !== -1) {
            selectedWarehousesClone.splice(index, 1);
            setSelectAll(false);
        } else {
            selectedWarehousesClone.push(branchId + '');
        }
        setSelectedWarehouses(selectedWarehousesClone);
    }
    const handleIndicateSaveClose = () => {
        if(oldSelectedPartner.current !== selectedPartner) {
            setSelectedPartner(oldSelectedPartner.current);
        }
        setIndicateSaveOpen(false);
    }
    const handleSubmit = (isSaveClose = false) => {
        let params = {
            partner_id: oldSelectedPartner.current,
            city: selectedCombined
        }
        dispatch(modifyPartnersWarehouse(params))
        .then(() => {
            if(isSaveClose) {
                dispatch(handleOpenDeliveryAreaFormDialog({open: false}));
                dispatch(showAlertSnackbar({message: t('save_success'), type: 'success'}));
            } else {
                oldSelectedPartner.current = selectedPartner;
                getLatestWarehousesPartners(false);
                handleGetSelectedWarehouses();
            }
        })
        .catch((err) => {
            dispatch(showAlertSnackbar({message: err.message, type: 'error'}));
            setSelectedPartner(oldSelectedPartner.current);
        })
        .finally(() => {
            setIndicateSaveOpen(false);
        })
    }
    const handleGetSelectedWarehouses = () => {
        let exist = false;
        savedRelationship.map((relation) => {
            if(relation.partner_id + '' === selectedPartner + '') {
                setSelectedWarehouses(relation.auth);
                setAuth(relation.auth);
                setNoAuth(relation.noAuth);
                exist = true;
                return;
            }
        })
        if(!exist) {
            setSelectedWarehouses([]);
            setAuth([]);
            setNoAuth([]);
        }
    }
    const getLatestWarehousesPartners = (isOriginal) => {
        dispatch(getPartnersWarehouse())
        .then((res) => {
            if(res.length > 0) {
                res.map((relation) => {
                    let savedCitiesNoAuth = [];
                    let savedCities = [];
                    if(relation.city) {
                        let cities = relation.city.split(',');
                        cities.map((city) => {
                            if(authorizedWarehouses.indexOf(Number(city)) === -1) {
                                savedCitiesNoAuth.push(city);
                            } else {
                                savedCities.push(city);
                            }
                        })
                    }
                    relation.noAuth = savedCitiesNoAuth;
                    relation.auth = savedCities;
                    if(relation.partner_id === oldSelectedPartner.current && !isOriginal) {
                        setSelectedWarehouses(savedCities);
                        setAuth(savedCities);
                        setNoAuth(savedCitiesNoAuth);
                    }
                })
                setSavedRelationship(res);
            }
        })
        .catch((err) => {
            dispatch(showAlertSnackbar({message: err.message, type: 'error'}));
        })
    }

    useEffect(() => {
        if(selectedPartner) {
            setSelectAll(false);
            if(oldSelectedPartner.current !== selectedPartner) {
                if(_.isEqual(auth.sort(), selectedWarehouses.sort())) {
                    oldSelectedPartner.current = selectedPartner;
                    handleGetSelectedWarehouses();
                } else {
                    setIndicateSaveOpen(true);
                }
            } else {
                handleGetSelectedWarehouses();
            }
        }
    }, [selectedPartner])
    useEffect(() => {
        let currCities = selectedWarehouses.toString();
        if(selectedWarehouses.length > 0) {
            if(noAuth.length > 0) {
                currCities += ',' + noAuth.toString();
            }
        } else {
            if(noAuth.length > 0) {
                currCities = noAuth.toString();
            }
        }
        setSelectedCombined(currCities);
    }, [selectedWarehouses])
    useEffect(() => {
        if(openModalObject?.open && openModalObject?.id === 0) {
            setSelectedPartner(null);
            setSelectedWarehouses([]);
            getLatestWarehousesPartners(true);
            setAuth([]);
            setNoAuth([]);
        }
    }, [openModalObject])

    return (
        <UniDialog
            open={openModalObject.open && openModalObject.id === 0}
            onClose={onClose}
            maxWidth='md'
            fullWidth
            disableDefaultButtons
            title={t('partner_management')}
        >
            <Grid container spacing={1}>
                <Grid item xs={6} className={classes.leftPanel}>
                {
                    partners?.length > 0 &&
                    <RadioGroup 
                        value={selectedPartner+''||partners[0].id+''}
                        onChange={handleSelectedPartner}
                        className={classes.radioGroup}
                    >
                    {
                        partners.map((partner, index) => (
                        <FormControlLabel 
                            key={index} 
                            value={partner.id + ''} 
                            control={<Radio />} 
                            label={partner.name} 
                        /> 
                        ))
                    }
                    </RadioGroup>
                }
                </Grid>
                <Grid item xs={6}>
                    <div className={classes.rightPanel}>
                    {
                        warehouses?.length > 0 &&
                        warehouses.map((warehouse, index) => (
                            <div style={{display: 'flex', alignItems: 'center'}} key={warehouse.id}>
                                <Checkbox
                                    color="secondary"
                                    onClick={() => handleWarehouseClick(warehouse.id)}
                                    checked={selectedWarehouses.indexOf(warehouse.id + '') !== -1}
                                    disabled={selectedPartner===null}
                                />
                                <span>{warehouse.name}</span>
                            </div>
                        ))
                    }
                    </div>
                    <div className={classes.rightBottomPanel}>
                        <div>
                            <Checkbox
                                color="secondary"
                                onClick={handleAllWarehousesClick}
                                checked={selectAll}
                                disabled={selectedPartner===null}
                            />
                            <span>{t('select_all')}</span>
                        </div>
                        <div>
                            <Button 
                                color='primary' 
                                variant='contained'
                                onClick={()=>handleSubmit(true)}
                                disabled={selectedPartner===null}
                            >
                                {t('save')}
                            </Button>
                        </div>
                    </div>
                </Grid>
            </Grid>
            <UniDialog
                fullWidth
                open={indicateSaveOpen}
                onClose={handleIndicateSaveClose}
                onFinish={()=>handleSubmit(false)}
                autoClose={false}
            >
                {t('confirm_to_submit')}
            </UniDialog>
        </UniDialog>
    )
}

export default AssignmentDialog;